import _uniqueId from 'lodash/uniqueId';

/**
 * Returns a random unique ID.
 * @param {string} [prefix] - Optional prefix.
 */
export const getUniqueId = (prefix?: string) => _uniqueId(prefix);
